var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageloader has-text-centered",class:{'is-active':this.$store.getters.insight_isLoadingResultats}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("loading.patienter")))])])}
var staticRenderFns = []

export { render, staticRenderFns }